import { get, post } from '@/request/request'

export default {
    tree() {
        return get('/admin/department/tree')
    },
    save(params) {
        return post('/admin/department/save',params)
    },
    delete(params) {
        return post('/admin/department/delete', params)
    }

}